import { render, staticRenderFns } from "./CommonNodeLabel.vue?vue&type=template&id=fea4db82&scoped=true&"
import script from "./CommonNodeLabel.vue?vue&type=script&lang=js&"
export * from "./CommonNodeLabel.vue?vue&type=script&lang=js&"
import style0 from "./CommonNodeLabel.vue?vue&type=style&index=0&id=fea4db82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea4db82",
  null
  
)

export default component.exports